module.exports = __webpack_public_path__ + "img/4.f049a4a8.jpg";